import React, { useState, useEffect } from 'react'
import { Col, Container, Row, Button } from "react-bootstrap"
import { FaHistory, FaPlus, FaPencilAlt } from 'react-icons/fa'
import $ from 'jquery';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import Loader from "./Loader";

import AddTenant from './AddTenant'
import EditTenant from './EditTenant'
import ManageTenantAudit from './Manage_Tenant_Audit'
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import N from '../lib/Network';
import S from '../lib/Security';
var CryptoJS = require("crypto-js");
const ManageTenant = () => {
    const [showUserPopup, setShowUserPopup] = useState(false);
    const [showUserPopupAudit, setshowUserPopupAudit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showUserPopupEdit, setShowUserPopupEdit] = useState(false);
    const [data, setData] = useState([]);
    const [oldRecord,setOldRecord] = useState([]);
    useEffect(() => {
        showLoaderPopup();
        getKeys();
        fetchdatatableData();
        //initialize datatable
        setTimeout(function () {
            $('#viewTenant').DataTable({
                pagingType: 'full_numbers',
                pageLength: 7,
                processing: true,
                dom: 'Bfrtip',
                "order": [[ 2, "desc" ]],
                
                "columns":[  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    {},
                ],
                language: { search: "", searchPlaceholder: "Search By Tenant Name"},
                buttons: [
                    {
                        text: '<i class="fa fa-print" />',
                        className: 'custom-btn',
                        extend: 'print'
                    },
                    {
                        text: '<i class="fa fa-file-excel-o" />',
                        className: 'custom-btn',
                        extend: 'csv'
                    }
                ],
                bDestroy: true,
                "initComplete": function() {
                    $(this).show();
                }
            });
            closeLoader();
        }, 1400 );
    }, []);
    const fetchdatatableData = () => {
        N.getApi('getTenantList')
        .then(res => {
        var response = S.getDecryptedJSON(res);
            setData(JSON.parse(response.responseJson))
        })
    }
    function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
          N.getRSAApi('/getRsaKeys')
          .then(res => {
              let resObj = JSON.parse(res.data);
              let resJson = JSON.parse(resObj.responseJson);
              if(resJson.privateKey && resJson.publicKey){
                  let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                  // Decrypt
                  var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
      
                  var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
                  fetchdatatableData();
              }
          })
          .catch(err => {
              console.log("Error : "+err);
          });
        }
    }
    const openPreviewModalHandler = () => { setShowUserPopup(true)  }
    const showLoaderPopup = () => { setShowLoader(true) }
    const openAuditModalHandler = () => { setshowUserPopupAudit(true) }
    const closeAuditPopup = () => { setshowUserPopupAudit(false) }
    const closeLoader = () => { setShowLoader(false) }
    const closePopup = () => { setShowUserPopup(false) }
    const closeEditPopup = () => { setShowUserPopupEdit(false) }
    const handleEdit =(oldData)=> {setOldRecord({oldData}); setShowUserPopupEdit(true); }
    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="wrapper">
                {<Sidebar />}
                {<Topbar />}
                {/* <!-- End of Topbar --> */}
                {/* <!-- Main Content --> */}
                <div id="content">
                    {/* <!-- Begin Page Content --> */}
                    <Container fluid>
                        <Row>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 mb-2 mt-2">
                                <div className="card dash-data-card">
                                    <div className="card-header pl-4 pr-4">
                                        <h5 className="headerTitle float-left mt-1">Manage Tenants</h5>
                                        <Button variant='light' type="button" className="btn btn-sm shadow-sm float-right ml-2" title="Audit Log" onClick={()=>{openAuditModalHandler();}}>
                                            <FaHistory className="fas fa-plus" /><b style={{verticalAlign: 'middle'}}>Audit Log</b>
                                        </Button>
                                        {(localStorage.getItem("isCreateTenantRole")) ?
                                        <Button type="button" className="btn btn-sm btn-primary shadow-sm float-right" onClick={openPreviewModalHandler}>
                                            <FaPlus className="fas fa-plus pr-1" /><b style={{verticalAlign: 'middle'}}>Create Tenant</b>
                                        </Button>
                                        : null }
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row className="mb-3">
                            <Col lg='12'>
                                <div className="card dash-data-card">
                                    <div className="card-body pl-4 pr-4">
                                        {(localStorage.getItem("isModifyTenantRole")) ?
                                            <table id="viewTenant" className="display">
                                                <thead>
                                                    <tr>
                                                        <th>Tenant Name</th>
                                                        <th>Address</th>
                                                        <th>Company Name</th>
                                                        <th>Company Reg No</th>
                                                        <th>Tenant Spoc</th>
                                                        <th>Tenant Email Id</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {data?.Payload?.tenantList?.map((result) => {
                                                    return (
                                                        <tr>
                                                            <td>{result.TenantName}</td>
                                                            <td>{result.Address}</td>
                                                            <td>{result.companyName}</td>
                                                            <td>{result.companyRegNo}</td>
                                                            <td>{result.tenantSpoc}</td>
                                                            <td>{result.tenantEmailId}</td>
                                                            <td>
                                                                <Button variant='light' className='btn-sm' onClick={()=>handleEdit(result)}><FaPencilAlt /></Button>
                                                            </td>
                                                        </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                            : <table id="viewTenant" className="display">
                                            <thead>
                                                <tr>
                                                    <th>Tenant Name</th>
                                                    <th>Address</th>
                                                    <th>Company Name</th>
                                                    <th>Company Reg No</th>
                                                    <th>Tenant Spoc</th>
                                                    <th>Tenant Email Id</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.Payload?.tenantList?.map((result) => {
                                                return (
                                                    <tr>
                                                        <td>{result.TenantName}</td>
                                                        <td>{result.Address}</td>
                                                        <td>{result.companyName}</td>
                                                        <td>{result.companyRegNo}</td>
                                                        <td>{result.tenantSpoc}</td>
                                                        <td>{result.tenantEmailId}</td>
                                                        <td></td>
                                                    </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Loader showLoader={showLoader} />
                    <AddTenant showUserPopup={showUserPopup} closeModal={closePopup}/>
                    {showUserPopupAudit ? <>
                       <ManageTenantAudit showUserPopupAudit={showUserPopupAudit} closeModal={closeAuditPopup} />
                    </> : null 
                    }
                    {showUserPopupEdit ? <>
                    <EditTenant oldRecord={oldRecord} showUserPopupEdit={showUserPopupEdit} closeEditModal={closeEditPopup}/>
                    </>:null
                    }
                    {/* <!-- /.container-fluid --> */}
                </div>
            </div>
        </div>
    )
}
export default ManageTenant;